// extracted by mini-css-extract-plugin
export default {"form":"LW9eTPOSeSRVseNt1IZs","terms":"h1fTBvs4PbmYWdDmnylf","applePayButton":"csdZJRH26_KahkbZNLE3","divider":"KhVgmN598GizUPnS8Sry"};